import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import zhTW from './zh-TW.json'
import en from './en.json'

const LANG_STORAGE_KEY = 'tg_game_lang'

function detectLanguage(): string {
  try {
    const stored = localStorage.getItem(LANG_STORAGE_KEY)
    if (stored === 'en' || stored === 'zh-TW') return stored
  } catch {
    /* ignore */
  }
  const nav = (typeof navigator !== 'undefined' ? navigator.language : '') || ''
  if (nav.toLowerCase().startsWith('en')) return 'en'
  return 'zh-TW'
}

void i18n.use(initReactI18next).init({
  resources: {
    'zh-TW': { translation: zhTW },
    en: { translation: en },
  },
  lng: detectLanguage(),
  fallbackLng: 'zh-TW',
  supportedLngs: ['zh-TW', 'en'],
  interpolation: { escapeValue: false },
})

if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.language?.startsWith('en') ? 'en' : 'zh-Hant'
}

export function translateApiError(msg: string | null | undefined, t: (k: string) => string): string {
  if (!msg) return t('errors.unknown')
  const lower = msg.toLowerCase()
  const pairs: [string, string][] = [
    ['insufficient funds', 'errors.insufficient_funds'],
    ['user not found', 'errors.user_not_found'],
    ['invalid bet', 'errors.invalid_bet'],
    ['invalid risk', 'errors.invalid_risk'],
    ['unauthorized', 'errors.unauthorized'],
    ['play failed', 'errors.play_failed'],
  ]
  for (const [needle, key] of pairs) {
    if (lower.includes(needle)) return t(key)
  }
  return msg
}

export default i18n
